export default "__VITE_ASSET__CWiZMlIv__"